module.exports = __webpack_public_path__ + "static/media/thirdareaproduct2.0615180a.jpg";